// src/components/VisitorContactWidget/components/ContactWidgetHome.jsx

import React from "react";

import {
  FiArrowRight,
  FiCalendar,
  FiMessageCircle,
  FiPhoneCall,
  FiPlayCircle,
} from "react-icons/fi";

import {
  CONTACT_WIDGET_VIEWS,
} from "../data/contactWidgetData";

function ActionCard({
  icon: Icon,
  title,
  description,
  onClick,
  accentClassName,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4 text-left transition hover:-translate-y-0.5 hover:border-[#2EA7E0] hover:shadow-md"
    >
      <span
        className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-xl ${accentClassName}`}
      >
        <Icon />
      </span>

      <span className="min-w-0 flex-1">
        <span className="block font-semibold text-[#123B57]">
          {title}
        </span>

        <span className="mt-1 block text-xs leading-5 text-slate-500">
          {description}
        </span>
      </span>

      <FiArrowRight className="shrink-0 text-slate-300 transition group-hover:translate-x-1 group-hover:text-[#2EA7E0]" />
    </button>
  );
}

export default function ContactWidgetHome({
  hasConversation,
  onSelectView,
}) {
  return (
    <div className="space-y-4 p-5">
      <div className="rounded-2xl bg-[#EEF7FC] p-4">
        <p className="text-sm leading-6 text-slate-700">
          Bonjour 👋
        </p>

        <p className="mt-1 text-sm leading-6 text-slate-600">
          Je développe des applications pour simplifier la
          gestion des clubs, associations et événements
          sportifs.
        </p>
      </div>

      {hasConversation && (
        <ActionCard
          icon={FiMessageCircle}
          title="Reprendre la conversation"
          description="Consultez mes réponses et poursuivez notre échange."
          accentClassName="bg-emerald-50 text-emerald-600"
          onClick={() =>
            onSelectView(CONTACT_WIDGET_VIEWS.CHAT)
          }
        />
      )}

      <ActionCard
        icon={FiMessageCircle}
        title="Poser une question"
        description="Envoyez-moi votre question directement depuis le site."
        accentClassName="bg-blue-50 text-blue-600"
        onClick={() =>
          onSelectView(
            hasConversation
              ? CONTACT_WIDGET_VIEWS.CHAT
              : CONTACT_WIDGET_VIEWS.QUESTION,
          )
        }
      />

      <ActionCard
        icon={FiPhoneCall}
        title="Être rappelé"
        description="Choisissez le jour et le créneau qui vous conviennent."
        accentClassName="bg-amber-50 text-amber-600"
        onClick={() =>
          onSelectView(
            CONTACT_WIDGET_VIEWS.CALLBACK,
          )
        }
      />

      <ActionCard
        icon={FiPlayCircle}
        title="Demander une démonstration"
        description="Découvrez une présentation adaptée à votre club."
        accentClassName="bg-violet-50 text-violet-600"
        onClick={() =>
          onSelectView(CONTACT_WIDGET_VIEWS.DEMO)
        }
      />

      <div className="flex items-center justify-center gap-2 pt-2 text-xs text-slate-400">
        <FiCalendar />
        Réponse personnalisée, sans engagement
      </div>
    </div>
  );
}